import { useLowFrequencyRefreshQuery } from '../../../queryDefaults/baseQueries/useLowFrequencyRefreshQuery.tsx';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { QuestionnairesApi } from '../../../apis/QuestionnairesApi/QuestionnairesApi.ts';
import { IQuestionnaireCategoryConfig } from '../QuestionnaireCategoryConfig.ts';

export function useGetCategoryConfigs(questionnaireId: number | null | undefined) {
    return useLowFrequencyRefreshQuery({
        queryKey: [QueryKeys.questionnaire, questionnaireId, 'categoryConfigs'],
        queryFn: async (): Promise<IQuestionnaireCategoryConfig[]> => {
            if (!questionnaireId) return [];
            return await QuestionnairesApi.getCategoryConfigs(questionnaireId.toString());
        },
        enabled: !!questionnaireId,
    });
}
